<template>
  <div v-loading="isLoading">
    <div
      v-if="!dataLoaded"
      class="load-button-container"
    >
      <el-button
        type="primary"
        @click="loadData"
      >
        {{ $t("load_data") }}
      </el-button>
    </div>
    <template v-else>
      <div class="period-picker">
        <el-form
          size="medium"
          :inline="true"
          @submit.native.prevent
        >
          <period-picker
            v-model="dates"
            frequency="DAY"
          >
          </period-picker>
        </el-form>
      </div>
      <div class="graph">
        <new-lost-backlinks-graph
          :data="dataNewLostBacklinksCount"
          :dates="dates"
        >
        </new-lost-backlinks-graph>
      </div>
      <div>
        <grid :data="dataNewLostBacklinksData"> </grid>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { DateTime } from "luxon";
import Grid from "@/pages/Netlinking/Grids/NewLost/Grid";
import PeriodPicker from "@/pages/Netlinking/Grids/NewLost/PeriodPicker";
import NewLostBacklinksGraph from "@/pages/Netlinking/Grids/NewLost/NewLostBacklinks";
import { formatDateWithDashes } from "@/javascripts/formatDate";

export default {
  components: {
    Grid,
    PeriodPicker,
    NewLostBacklinksGraph,
  },
  data() {
    return {
      dates: [DateTime.utc().minus({ weeks: 1 }), DateTime.utc()],
      dataNewLostBacklinksData: null,
      dataNewLostBacklinksCount: null,
      isLoading: false,
      dataLoaded: false,
    };
  },
  methods: {
    loadData() {
      this.fetchNewLostBacklinks();
      this.fetchNewLostBacklinksCount();
    },
    fetchNewLostBacklinks() {
      let requestNewLostBacklinks = {};
      requestNewLostBacklinks.url = { url: this.study.url, type: "DOMAIN" };
      requestNewLostBacklinks.startDate = formatDateWithDashes(this.dates[0]);
      requestNewLostBacklinks.endDate = formatDateWithDashes(this.dates[1]);
      requestNewLostBacklinks.limit = 1000;
      this.isLoading = true;
      this.$emit("new-backlinks", null);
      this.$emit("lost-backlinks", null);
      this.$apiV2
        .post(`/netlinking/urls/backlinks/new-lost`, {
          ...requestNewLostBacklinks,
        })
        .then((response) => {
          this.dataNewLostBacklinksData = response.data;
          this.dataLoaded = true;
          this.$emit(
            "new-backlinks",
            this.dataNewLostBacklinksData.backlinksNewLost.newBacklinks.length
          );
          this.$emit(
            "lost-backlinks",
            this.dataNewLostBacklinksData.backlinksNewLost.lostBacklinks.length
          );
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.dataNewLostBacklinksData = {};
          console.log(error);
          this.$message({
            message: this.$i18n.t("fail_fetch_backlinks"),
            type: "error",
            duration: 6000,
            offset: 80,
          });
        });
    },
    fetchNewLostBacklinksCount() {
      let requestNewLostBacklinksCount = {};
      requestNewLostBacklinksCount.url = {
        url: this.study.url,
        type: "DOMAIN",
      };
      this.$apiV2
        .post(`/netlinking/urls/backlinks/new-lost-count`, {
          ...requestNewLostBacklinksCount,
        })
        .then((response) => {
          this.dataNewLostBacklinksCount = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: this.$i18n.t("fail_fetch_backlinks"),
            type: "error",
            duration: 6000,
            offset: 80,
          });
        });
    },
  },
  computed: {
    ...mapState(["study"]),
  },
  watch: {
    dates() {
      if (this.dataLoaded) {
        this.fetchNewLostBacklinks();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.graph {
  margin-bottom: 1rem;
}

.period-picker {
  text-align: center;
  margin-top: 0.3rem;
}

.load-button-container {
  text-align: center;
  padding: 2rem 0;
}
</style>
<i18n>
{
  "en": {
    "fail_fetch_backlinks": "Backlinks : Error encountered",
    "load_data": "Load data"
  },
  "fr": {
    "fail_fetch_backlinks": "Backlinks : Nous avons rencontré une erreur",
    "load_data": "Charger les données"
  },
  "de": {
    "fail_fetch_backlinks": "Backlinks: Es ist ein Fehler aufgetreten",
    "load_data": "Daten laden"
  }
}
</i18n>
